import { createEntityClient, runQueuedMutation } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { VisibleFieldsEditModel } from './visibleFieldModel';
import { visibleFieldContract } from './visibleFieldContract';

/**
 * Visible fields of the selected project, as served by the service worker. An
 * edit resolves once the server saved it and rejects with its error
 * (`ChannelRequestError.messageId`).
 */
export const visibleFieldClient = {
  ...createEntityClient(visibleFieldContract),

  async edit(visibleFieldsEdit: VisibleFieldsEditModel): Promise<void> {
    await runQueuedMutation(
      visibleFieldContract,
      'edit',
      (uniqueId) => ({ visibleFieldsEdit, uniqueId }),
      DomainMessagesTypes.uploadedEntity
    );
  },
};
